// 资讯api
import { baseRequest } from './base'

/**
 * @desc 新闻列表
 */
function listNews(params) {
  params = utils.common.checkNull(params);
  console.log('listNews', params)
  //清除空白字段
  let tempUrl = `/api/school/listAnnouncement`
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 新建新闻
 */
function createNews(params) {
  return baseRequest(`/api/school/announcement`, 'put', params);
}

/**
 * @desc 修改新闻
 */
function updateNews(id, params) {
  return baseRequest(`/api/school/announcement/${id}`, 'post', params);
}

/**
 * @desc 删除新闻
 */
function deleteNews(id) {
  return baseRequest(`/api/school/announcement/${id}`, 'delete');
}

/**
 * @desc 上下架
 */

// function enable(id, enable) {
//     return baseRequest(`/api/news/enable/${id}/${enable}`, 'get');
// }

function enable(id,params) {
  params = utils.common.checkNull(params);
  //清除空白字段
  let tempUrl = `/api/school/announcement/${id}`
  return baseRequest(tempUrl, 'post', params);
}

export default {
  listNews: listNews,
  createNews: createNews,
  updateNews: updateNews,
  deleteNews: deleteNews,
  enable: enable
}